// extracted by mini-css-extract-plugin
export default {"ChoiceButton":"ChoiceButton___Lh8_v","ChoiceButton__icon":"ChoiceButton__icon___lvp8L","ChoiceButton__label":"ChoiceButton__label___PRQp1"};